import { BasicUserJwt } from "@egis-auth/client";

export interface StadePdaToken extends BasicUserJwt {
  username: string;
  terminalId: string;
  codeVille: string;
  matricule: string;
}

export enum LoginError {
  INVSN = "INVSN", // "Invalid serial number"
  LOG = "LOG", // "Login is not found"
  MP = "MP", // "Invalid parameters : Missing username or password"
  MSN = "MSN", // "Missing pda serial number"
  PASS = "PASS", // "Password is not valid"
  UN1 = "UN1", // "Unauthorized"
  UN2 = "UN2", // "Unauthorized"
  UN3 = "UN3", // "Unauthorized"
}
